import type { CSSProperties } from 'react';

/**
 * Regra do dono (31/10/2026): NENHUM navegador pode salvar login nem senha do InovaPay.
 *
 * O Chrome/Edge/Safari só oferecem salvar (e preenchem sozinhos) quando o campo é
 * `type="password"` — e marcam o campo como "de senha" para sempre se ele foi password
 * por um instante. Por isso o campo de senha é SEMPRE `type="text"` e as bolinhas são
 * desenhadas por CSS (`-webkit-text-security`). O olho só liga/desliga as bolinhas.
 */
export function propsDeSenhaQueNaoSalva(visivel = false) {
  const estilo = (visivel ? {} : { WebkitTextSecurity: 'disc' }) as CSSProperties;
  return {
    type: 'text',
    autoComplete: 'off',
    autoCorrect: 'off',
    autoCapitalize: 'none',
    spellCheck: false,
    style: estilo,
    'data-lpignore': 'true',
    'data-1p-ignore': 'true',
    'data-form-type': 'other',
  } as const;
}

/** Campo de login/usuário: sem lista de sugestões do navegador. */
export const propsDeLoginQueNaoSalva = {
  autoComplete: 'off',
  autoCorrect: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-form-type': 'other',
} as const;
